import {
  SYNC_ARCHIVIO,
  SYNC_ARCHIVIO_PROGRESS,
  SYNC_ARCHIVIO_SUCCESS,
  SYNC_ARCHIVIO_FAIL,
  ARCHIVIO_LOCAL_CHANGED,
} from "./actionTypes"

// I record non stanno nello store (sono in localforage + cache in memoria, vedi helpers/archivio_store):
// qui solo lo stato della sincronizzazione. "version" cambia ogni volta che i record in cache cambiano.
const initTipo = { status: "idle", count: 0, lastSync: null, version: 0, error: null }

const INIT_STATE = {
  ordini: initTipo,
  offerte: initTipo,
}

const updateTipo = (state, tipo, changes) => ({
  ...state,
  [tipo]: { ...state[tipo], ...changes },
})

const archivio = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SYNC_ARCHIVIO:
      return updateTipo(state, action.payload.tipo, { status: "loading", error: null })

    case SYNC_ARCHIVIO_PROGRESS:
      return updateTipo(state, action.payload.tipo, {
        count: action.payload.count,
        version: state[action.payload.tipo].version + 1,
      })

    case SYNC_ARCHIVIO_SUCCESS:
      return updateTipo(state, action.payload.tipo, {
        status: "ok",
        count: action.payload.count,
        lastSync: action.payload.lastSync,
        version: state[action.payload.tipo].version + 1,
      })

    case SYNC_ARCHIVIO_FAIL:
      return updateTipo(state, action.payload.tipo, { status: "error", error: action.payload.error })

    case ARCHIVIO_LOCAL_CHANGED:
      return updateTipo(state, action.payload.tipo, { version: state[action.payload.tipo].version + 1 })

    default:
      return state
  }
}

export default archivio
